import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '../../molecules';
import { breakPoints } from './constant';
import { FoodComparisonChartItem } from './FoodComparisonChartItem';
import { FoodContainer } from './styles';

export const FoodComparison = ({ charts }) => (
  <FoodContainer>
    <Carousel dotPadding={8} breakPoints={breakPoints} buttonPosition="17">
      {charts.map((props, index) => (
        <FoodComparisonChartItem key={index} {...props} />
      ))}
    </Carousel>
  </FoodContainer>
);

FoodComparison.displayName = 'FoodComparison';

FoodComparison.propTypes = {
  charts: PropTypes.array.isRequired,
};
